// import React from "react";
// import { useNavigate } from "react-router-dom";

// const Popular_Brands = () => {
//   const brandImages = [
//     {
//       name: "Bajaj",
//       url: "./bajaaj.png"
//     },
//     {
//       name: "Blue Star",
//       url: "./Blue star.png"
//     },
//     {
//       name: "Bosch",
//       url: "./bosch.png"
//     },
//     {
//       name: "Canon",
//       url: "./Canon.png"
//     },
//     {
//       name: "Carrier",
//       url: "./Carrier.png"
//     },
//     {
//       name: "Daikin",
//       url: "./Daikin.png"
//     },
//     {
//       name: "Dell",
//       url: "./Dell.png"
//     },
//     {
//       name: "Eureka",
//       url: "./Eureka.png"
//     },
//     {
//       name: "Fire",
//       url: "./fire.png"
//     },
//     {
//       name: "Youder",
//       url: "./youder.png"
//     },
//     {
//       name: "Haier",
//       url: "./haier.png"
//     },
//     {
//       name: "Hitachi",
//       url: "./hitachi.png"
//     },
//     {
//       name: "HP",
//       url: "./hp.png"
//     },
//     {
//       name: "IFB",
//       url: "./ifb.png"
//     },
//     {
//       name: "Kent",
//       url: "./kent.png"
//     },
//     {
//       name: "Kutchina",
//       url: "./kutchina.png"
//     },
//     {
//       name: "Lenovo",
//       url: "./lenovo.png"
//     },
//     {
//       name: "LG",
//       url: "./lg.png"
//     },
//     {
//       name: "Lloyd",
//       url: "./lloyd.png"
//     },
//     {
//       name: "Mi",
//       url: "./mi.png"
//     },
//     {
//       name: "Nikon",
//       url: "./nikon.png"
//     },
//     {
//       name: "Oppo",
//       url: "./oppo.png"
//     },
//     {
//       name: "Panasonic",
//       url: "./panasonic.png"
//     },
//     {
//       name: "Samsung",
//       url: "./samsung.png"
//     },
//     {
//       name: "Saregama",
//       url: "./saregma.png"
//     },
//     {
//       name: "Sony",
//       url: "./sony.png"
//     },
//     {
//       name: "Usha",
//       url: "./usha.png"
//     },
//     {
//       name: "Vivo",
//       url: "./vivo.png"
//     },
//     {
//       name: "Apple",
//       url: "./apple.png"
//     }
//   ];
//   const navigate = useNavigate();
//   return (
//     <div className="container-md" style={{
//       // width: '100%',
//       // margin: '2% 5%', 
//       background: "rgba(255, 255, 255, 0.3)",
//       borderRadius: "16px",
//       boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
//       backdropFilter: "blur(0.6px)",
//       WebkitBackdropFilter: "blur(0.6px)", // Note: React automatically handles vendor prefixes, but this is still used for clarity and compatibility
//       border: "1px solid rgba(255, 255, 255, 0.3)",
//       padding: '20px'
//     }}>
//       <div className="container-md" style={{ marginTop: '20px', marginBottom: '100px' }}>
//         <p style={{
//           background: 'linear-gradient(white, white) padding-box, linear-gradient(to right, rgb(255, 0, 0) 30px, rgb(0,0,0) 70%, rgba(255, 255, 255, 0.804)) border-box',
//           borderBottom: '2px solid transparent',
//           // borderTop: '2px solid transparent',
//           // borderTop: 'none',
//           borderLeft: 'none',
//           borderRight: 'none',
//           borderBottomRightRadius: '30px',
//           padding: '5px', fontSize: '1.4rem', fontWeight: '600',
//         }}>POPULAR BRANDS</p>
//       </div>
//       <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }} className=" container-md Papular_brands">
//         {
//           brandImages.map((brand, index) => (
//             <div key={index} style={{ cursor: 'pointer' }} onClick={() => navigate(`/brands/${brand.name}`)}><img src={brand.url} /></div>
//           ))
//         }
//       </div>
//     </div>
//   );

// };
// export default Popular_Brands


import React from "react";
import { useNavigate } from "react-router-dom";
import "./Popular_Brands.css"; // Import the external CSS file

const Popular_Brands = () => {
  const brandImages = [
    { name: "Bajaj", url: "./bajaaj.png" },
    { name: "Blue Star", url: "./Blue star.png" },
    { name: "Bosch", url: "https://khoslaslider.s3.ap-south-1.amazonaws.com/Bosch.png" },
    { name: "Canon", url: "./Canon.png" },
    { name: "Carrier", url: "./Carrier.png" },
    { name: "Daikin", url: "./Daikin.png" },
    { name: "Dell", url: "./Dell.png" },
    { name: "Eureka", url: "./Eureka.png" },
    { name: "Fire", url: "./fire.png" },
    { name: "Godrej", url: "./youder.png" },
    { name: "Haier", url: "./haier.png" },
    { name: "Hitachi", url: "./hitachi.png" },
    { name: "HP", url: "./hp.png" },
    { name: "IFB", url: "./ifb.png" },
    { name: "Kent", url: "./kent.png" },
    { name: "Kutchina", url: "./kutchina.png" },
    { name: "Lenovo", url: "./lenovo.png" },
    { name: "LG", url: "./lg.png" },
    { name: "Lloyd", url: "./lloyd.png" },
    { name: "Mi", url: "./mi.png" },
    { name: "Nikon", url: "./nikon.png" },
    { name: "Oppo", url: "./oppo.png" },
    { name: "Panasonic", url: "./panasonic.png" },
    { name: "Samsung", url: "./samsung.png" },
    { name: "Saregama", url: "./saregma.png" },
    { name: "Sony", url: "./sony.png" },
    { name: "Usha", url: "./usha.png" },
    { name: "Vivo", url: "./vivo.png" },
    { name: "Apple", url: "./apple.png" },
    { name: "KGA" , url: "./kga.jpg"}
  ];

  const navigate = useNavigate();

  return (
    <div className="Popular_Brands-container">
      <div className="Popular_Brands-title-container">
        <p className="Popular_Brands-title">POPULAR BRANDS</p>
      </div>
      <div className="Popular_Brands-grid">
        {brandImages.map((brand, index) => (
          <div
            key={index}
            className="Popular_Brands-item"
            onClick={() => navigate(`/brands/${brand.name}`)}
          >
            <img src={brand.url} alt={brand.name} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Popular_Brands;
